"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickbooksConnectPaymentData = exports.QuickbooksConnectCreatePaymentData = void 0;
const typebox_1 = require("@sinclair/typebox");
const payment_transport_1 = require("../invoice/payment-transport");
exports.QuickbooksConnectCreatePaymentData = typebox_1.Type.Object({
    payment: payment_transport_1.PaymentTransport,
    type: typebox_1.Type.Union([typebox_1.Type.Literal('receivable'), typebox_1.Type.Literal('payable')]),
    // in this case it's the payable or receivable ID
    invoiceID: typebox_1.Type.String({ format: 'uuid' }),
});
exports.QuickbooksConnectPaymentData = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    invoiceID: typebox_1.Type.String({ format: 'uuid' }),
    type: typebox_1.Type.Union([typebox_1.Type.Literal('receivable'), typebox_1.Type.Literal('payable')]),
    platform: typebox_1.Type.Union([typebox_1.Type.Literal('sap'), typebox_1.Type.Literal('wayste')]),
    quickbooksSyncToken: typebox_1.Type.Optional(typebox_1.Type.String()),
    quickbooksID: typebox_1.Type.Optional(typebox_1.Type.String()),
    paymentDate: typebox_1.Type.String({ format: 'date-time' }),
    amount: typebox_1.Type.Integer(),
    paymentMethod: typebox_1.Type.String(),
    paymentIdentifier: typebox_1.Type.Optional(typebox_1.Type.String()),
    payoutIdentifier: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdated: typebox_1.Type.String({ format: 'date-time' }),
    lastSynced: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    lastSyncError: typebox_1.Type.Optional(typebox_1.Type.String()),
    retrySyncAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
});
//# sourceMappingURL=payment-data.js.map